var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Language") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,17.31l2.22-5.74,2.44,5.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.25,15h4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.59,4.11V7.2A3.6,3.6,0,0,1,4,10.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.59,4.11V7.2a2.7,2.7,0,0,0,.07.71,3.56,3.56,0,0,0,3.52,2.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.22,6.19H10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,8.49h7.17A1.3,1.3,0,0,1,22.5,9.85v8.39a1.35,1.35,0,0,1-1.29,1.36H19.35v2.08a.64.64,0,0,1-.65.64.44.44,0,0,1-.43-.21L15.9,19.53H10.24A1.31,1.31,0,0,1,9,18.16V14.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.59,1.68a6.52,6.52,0,0,1,4.59,1.93,6.38,6.38,0,0,1-.15,9,6.5,6.5,0,0,1-7.81.86l-2.44.93.93-2.22a6.34,6.34,0,0,1,.36-8.68A6.41,6.41,0,0,1,4.51,2.47,6.65,6.65,0,0,1,7.59,1.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage01);
export default __webpack_public_path__ + "static/media/Language_01.8918bf244e81149af87234a277b4d7cd.svg";
export { ForwardRef as ReactComponent };